import React, { useEffect, useRef, useState } from "react";

import { FaTrashAlt } from "react-icons/fa";
import { BsChevronDown, BsChevronUp, BsXLg } from "react-icons/bs";

import { betSlipService } from "../../services/BetSlip/BetSlipService";
import { appStore } from "../../stores/appStore";
import { sendRedirToReferral } from "../../services/common/globalFunctions";
import InfoMessages from "../InfoMessage/InfoMessage";
import Bonus from "../Bonus/Bonus";
import CustomModal from "../ui-components/CustomModal";
import { useTranslation } from "react-i18next";
import { StyledBetslipBonus, StyledBetslipCount, StyledBetslipHead, StyledBetslipModal, StyledBetslipOdds, StyledBetslipStakeBtn, StyledPlaceBtn, StyledSignleDeleteIcon } from "./BetslipStyle";
import { StyledLoader } from "../ui-components/LoaderStyle";
import { sessionService } from "../../services/Session/SessionService";

export const BetSlip = () => {
  const [showBonus, setShowBonus] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [stakeMinMaxErr, setStakeMinMaxErr] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [betResultStatus, setBetResultStatus] = useState();
  const [calculationSpinner, setCalculationSpinner] = useState(false);
  const [postBetslip, setPostBetslip] = useState({});
  const myDivRef = useRef(null);
  const [modalHeight, setModalHeight] = useState("");

  const noRegularExp = /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;
  let userSession = sessionService.getUserSession();
  const { t } = useTranslation("General");

  // getting and setting data from appStore
  const {
    showBetSlip,
    setShowBetSlip,
    calculatedBetSlip,
    setCalculatedBetSlip,
    betSlipSelections,
    countDownTimer,
    currentLeague,
    liveWeekNumber,
    setBetSlipSelections,
    betSlipDetails,
    setPlayerBalance,
    currencyCode,
    sessionCurrencyCode,
    generalConfig,
    setBetPlacedSelections,
    betPlacedSelections,
    playerBalance,
    leagueName,
    playerId,
    queryUrlData,
  } = appStore((state) => ({
    showBetSlip: state.showBetSlip,
    setShowBetSlip: state.setShowBetSlip,
    calculatedBetSlip: state.calculatedBetSlip,
    setCalculatedBetSlip: state.setCalculatedBetSlip,
    betSlipSelections: state.betSlipSelections,
    countDownTimer: state.countDownTimer,
    currentLeague: state.currentLeague,
    liveWeekNumber: state.liveWeekNumber,
    setBetSlipSelections: state.setBetSlipSelections,
    betSlipDetails: state.betSlipDetails,
    setPlayerBalance: state.setPlayerBalance,
    currencyCode: state.currencyCode,
    sessionCurrencyCode: state.sessionCurrencyCode,
    generalConfig: state.generalConfig,
    setBetPlacedSelections: state.setBetPlacedSelections,
    betPlacedSelections: state.betPlacedSelections,
    playerBalance: state.playerBalance,
    leagueName: state.leagueName,
    playerId: state.playerId,
    queryUrlData: state.queryUrlData,
  }));

  const [stakeValue, setStakeValue] = useState(Number(generalConfig.minStake));
  // if countDownTimer is 0 then betslip is clear
  useEffect(() => {
    if (countDownTimer === 0) {
      allOddsDelete();
      setModalShow(false);
    }
  }, [countDownTimer]);

  // if league and week id change then betslip is clear
  useEffect(() => {
    if (currentLeague.leagueId || liveWeekNumber) {
      allOddsDelete();
      setModalShow(false);
    }
  }, [currentLeague, liveWeekNumber]);

  // if betslip or stakeValue change then calculation function calling
  useEffect(() => {
    if (betSlipSelections.length > 0) {
      calculateBetSlip();
    }
  }, [betSlipSelections, stakeValue]);

  // input value set in the state
  // const selectedStake = (e) => {
  //   if (e?.nativeEvent?.data === '0') {
  //     setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
  //   }
  //   if (Number(e.target.value) < Number(generalConfig.minStake)) {
  //     setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
  //   } else {
  //     setStakeMinMaxErr("");
  //   }
  //   if (
  //     e.target.value === "" ||
  //     e.target.value === undefined ||
  //     noRegularExp.test(e.target.value)
  //   ) {
  //     setStakeValue(e.target.value || 0);
  //   }
  // };

  const selectedStake = (e) => {
    const inputValue = e.target.value;
    const numericValue = Number(inputValue);

    if (e?.nativeEvent?.data === '0') {
      setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
    }

    if (numericValue < Number(generalConfig.minStake)) {
      setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
    } else if (numericValue > Number(generalConfig.maxStake)) {
      setStakeMinMaxErr(`${t("stake must be less than or equal to")} ${generalConfig.maxStake}`);
      setStakeValue(generalConfig.maxStake); // Clamp to maxStake
      return;
    } else {
      setStakeMinMaxErr("");
    }

    if (
      inputValue === "" ||
      inputValue === undefined ||
      noRegularExp.test(inputValue)
    ) {
      setStakeValue(inputValue || 0);
    }
  };


  const updateStakeValue = (value) => {
    const current = parseFloat(stakeValue) || 0;
    const newValue = current + parseFloat(value);

    if (newValue > generalConfig.maxStake) {
      setStakeValue(generalConfig.maxStake);
      setStakeMinMaxErr(`${t("stake must be less than or equal to")} ${generalConfig.maxStake}`);
    } else if (newValue < generalConfig.minStake) {
      setStakeValue(generalConfig.minStake);
      setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
    } else {
      setStakeValue(newValue);
      setStakeMinMaxErr("");
    }
  };


  // betslip calculation API calling
  const calculateBetSlip = async () => {
    setCalculationSpinner(true);
    let betSlipReqDetails = { ...betSlipDetails };
    betSlipReqDetails.stake = +stakeValue;
    betSlipReqDetails.fkCountryId = "KE";
    betSlipReqDetails.selections = betSlipSelections;
    const response = await betSlipService.calculate(betSlipReqDetails, playerId);
    if (response.status === true) {
      if (userSession.token || userSession.operatorId == "demo") {
        if (stakeValue == 0) {
          // setStakeMinMaxErr("");
          setBtnDisabled(true);
        } else if (stakeValue > 0 && stakeValue < generalConfig.minStake) {
          setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake}`);
        } else if (stakeValue > generalConfig.maxStake && generalConfig.maxStake > 0) {
          setStakeMinMaxErr(`${t("stake must be less than or equal to")} ${generalConfig.maxStake.toFixed(2)}`);
        } else if (playerBalance < stakeValue) {
          setStakeMinMaxErr("Insufficient Balance");
          setBtnDisabled(true);
        } else {
          setStakeMinMaxErr("");
          setBtnDisabled(false);
        }
      }
      setCalculatedBetSlip(response.data);
      setCalculationSpinner(false);
    } else {
      setBtnDisabled(true);
      setStakeMinMaxErr(t(`${response.errorDetails}`));
      setCalculationSpinner(false);
    }
  };

  // stakeValue updating  

  // deleting all betslip odds selection
  const allOddsDelete = () => {
    betSlipSelections.splice(0, betSlipSelections.length);
    setBetSlipSelections(betSlipSelections);
    setStakeMinMaxErr("");
    if (betSlipSelections.length === 0) {
      setShowBetSlip(false);
      setStakeValue(0);
    }
  };

  // deleting selected single betslip odds selection
  const singleOddDelete = (index) => {
    betSlipSelections.splice(index, 1);
    setBetSlipSelections(betSlipSelections);
    setStakeMinMaxErr("");
    if (betSlipSelections.length === 0) {
      setShowBetSlip(false);
      setStakeValue(0);
    }
  };

  // hide the betslip component
  const betSlipClose = () => {
    setStakeMinMaxErr("");
    setShowBetSlip(false);
  };

  // show hide the bonus price
  const collapseIcon = () => {
    if (showBonus) {
      setShowBonus(false);
    } else {
      setShowBonus(true);
    }
  };

  useEffect(() => {
    setPostBetslip({
      betType: calculatedBetSlip.betType,
      fkCountryId: calculatedBetSlip.fkCountryId,
      fkLeagueId: calculatedBetSlip.fkLeagueId,
      fkSeasonId: calculatedBetSlip.fkSeasonId,
      fkWeekId: calculatedBetSlip.fkWeekId,
      rgsSession: calculatedBetSlip.rgsSession,
      selections: calculatedBetSlip.selections,
      stake: calculatedBetSlip.stake
    })
  }, [calculatedBetSlip])

  // placing the bet
  const placeBet = async () => {
    window.scrollTo(0, 0);
    window.parent.postMessage({ action: "scrolltotop" }, "*");
    if (stakeValue >= 0 && stakeValue < generalConfig.minStake) {
      setStakeMinMaxErr(`${t("stake must be greater than or equal to")} ${generalConfig.minStake.toFixed(2)}`);
    } else if (stakeValue > generalConfig.maxStake && generalConfig.maxStake > 0) {
      setStakeMinMaxErr(`${t("stake must be less than or equal to")} ${generalConfig.maxStake.toFixed(2)}`);
    } else if (playerBalance < stakeValue) {
      setStakeMinMaxErr("Insufficient Balance");
    } else {
      setSpinner(true);

      calculatedBetSlip.stake = +calculatedBetSlip.stake;
      delete postBetslip.status
      calculatedBetSlip.selections.forEach((ele) => { delete ele.status })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.gameName })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.homeTeam })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.awayTeam })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.selectedMarket.marketId })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.selectedMarket.marketName })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.outcomeDescription })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.selectedMarket.selectedOutCome.outcomeName })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.selectedMarket.selectedOutCome.outcomeValue })
      calculatedBetSlip.selections.forEach((ele) => { delete ele.selectedMarket.selectedOutCome.odds })

      const response = await betSlipService.placeBet(postBetslip, playerId);
      window.scrollTo(0, 0);
      window.parent.postMessage({ action: "scrolltotop" }, "*");
      if (response.status) {
        window.scrollTo(0, 0);
        window.parent.postMessage({ action: "scrolltotop" }, "*");
        setModalShow(true);
        setSpinner(false);
        setPlayerBalance(response?.data?.balance);
        setModalMsg("Your bet has been placed successfully");
        window.parent.postMessage({ action: "b2bupdateBalance" }, "*");
        setStakeValue(0);
      } else {
        setSpinner(false);
        if (response?.errorDetails && response?.errorDetails?.status === 1001) {
          // window.parent.postMessage({ action: "login" }, "*");
          setModalShow(true);
          setModalMsg("Insufficient funds");
        } else if (response?.errorDetails && response?.errorDetails?.status === 1002) {
          // window.parent.postMessage({ action: "login" }, "*");
          setModalShow(true);
          setModalMsg("Session Expired, Please Login Again");
        } else {
          if (typeof response?.errorDetails === "object") {
            setStakeMinMaxErr(t(`${response?.errorDetails?.message}`));
          } else {
            setStakeMinMaxErr(t(`${response?.errorDetails}`));
            setBetPlacedSelections(response?.selections);
          }
          // setModalShow(true);
          // setModalMsg(<div>{t(`${response.errorDetails}`)}</div>);
        }
      }
      setBetResultStatus(response.status);
    }
  };
  const handleClick = (type) => {
    sendRedirToReferral(type);
  }
  // based on condition show and hide the modal popup
  const modalClose = () => {
    if (betResultStatus) {
      allOddsDelete();
      setStakeValue(0);
      setShowBetSlip(false);
      setModalShow(false);
    } else {
      setModalShow(false);
    }
  };

  const [alreadyPlacedId, setAlreadyPlacedId] = useState([])

  useEffect(() => {
    const ids = [];
    betPlacedSelections.map((ele) => {
      ids.push(ele._id)
    })

    setAlreadyPlacedId(ids)
  }, [betPlacedSelections]);

  useEffect(() => {
    if (myDivRef.current) {
      const divHeight = myDivRef.current.clientHeight;
      setModalHeight(divHeight)
    }
  }, [calculatedBetSlip]);

  return (
    <React.Fragment>
      <div>
        <StyledBetslipModal
          className={`bet-slip position-absolute w-100 top-0 bottom-0 
          ${showBetSlip ? "show" : "hide"}`}
        >
          <div className="border bg-white border-0 p-0 m-0 w-100" ref={myDivRef}>
            <div className="card border border-0 rounded-0 h-auto">
              <CustomModal
                modalClose={modalClose}
                modalShow={modalShow}
                modalMsg={modalMsg}
                modalHeight={modalHeight}
              />
              <StyledBetslipHead className="card-header bg-primary border border-0 text-white w-100 rounded-0 p-2 m-0">
                <div className="d-flex justify-content-between py-2 align-items-center">
                  <h5 className="m-0 d-flex justify-content-start align-items-center fw-bold betslip-heading">
                    {t("Betslip")}{" "}
                    <StyledBetslipCount className="bg-secondary rounded fw-normal text-center ms-1 d-flex justify-content-center align-items-center betslip-length">
                      {betSlipSelections.length}
                    </StyledBetslipCount>
                  </h5>
                  <div className="d-flex align-items-center">
                    <FaTrashAlt
                      onClick={allOddsDelete}
                      className="ms-3 me-1 cursor"
                      size="15px"
                    />
                    <BsXLg
                      onClick={betSlipClose}
                      className="mx-3 cursor"
                      size="12px"
                    />
                  </div>
                </div>
              </StyledBetslipHead>
              <div className="card-body p-0 border border-0">
                {betSlipSelections.length === 0 ? (
                  <InfoMessages messages={<div>{t("Your Betslip is empty.")}</div>} />
                ) : (
                  <ul className="list-group list-group-flush bg-white text-dark">
                    {betSlipSelections.map((betGame, index) => {
                      const leagueDisplayName = leagueName && leagueName?.leaguePrefix ? leagueName?.leaguePrefix + currentLeague?.leagueName?.split("-")[1] : currentLeague?.leagueName;
                      return (
                        <li className={`list-group-item d-flex justify-content-between align-items-center py-1 px-2 bg-white text-dark 
                            ${alreadyPlacedId.includes(betGame.selectedMarket.selectedOutCome._id) && "border border-danger"}
                            ${alreadyPlacedId.includes(betGame._id) && "border border-danger"}
                        `}
                          key={index}
                        >
                          <div className="d-flex align-items-center">
                            <StyledSignleDeleteIcon>
                              <BsXLg
                                className="cursor"
                                onClick={() => singleOddDelete(index)}
                                size="12px"
                              />
                            </StyledSignleDeleteIcon>
                            <div className="d-flex flex-column ms-2">
                              <div className="fs-5 text-black">
                                <div>
                                  {betGame.selectedMarket.marketId === 4 && (
                                    <span>
                                      {betGame.selectedMarket.selectedOutCome
                                        .outcomeName === "12" ? (
                                        <span>
                                          {t(`${betGame.homeTeam}`)} {t("or")}{" "}
                                          {t(`${betGame.awayTeam}`)}
                                        </span>
                                      ) : (
                                        <span>
                                          {betGame.selectedMarket
                                            .selectedOutCome.outcomeName ===
                                            "1X" ? (
                                            <span>{t(`${betGame.homeTeam}`)} {t("Draw")}</span>
                                          ) : (
                                            <span>{t(`${betGame.awayTeam}`)} {t("Draw")}</span>
                                          )}
                                        </span>
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {betGame.selectedMarket.marketId === 1 && (
                                    <span>
                                      {betGame.selectedMarket.selectedOutCome
                                        .outcomeName === "1" ? (
                                        <span>{t(`${betGame.homeTeam}`)}</span>
                                      ) : (
                                        <span>
                                          {betGame.selectedMarket
                                            .selectedOutCome.outcomeName ===
                                            "X" ? (
                                            <span>{t("Draw")}</span>
                                          ) : (
                                            <span>{t(`${betGame.awayTeam}`)}</span>
                                          )}
                                        </span>
                                      )}
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {(betGame.selectedMarket.marketId === 2 ||
                                    betGame.selectedMarket.marketId === 3 ||
                                    betGame.selectedMarket.marketId === 6 ||
                                    betGame.selectedMarket.marketId === 7) && (
                                      <span>
                                        {t(`${betGame.selectedMarket.selectedOutCome.outcomeName}`)
                                        }{" "}
                                        {betGame.selectedMarket.selectedOutCome
                                          .outcomeValue > 0 &&
                                          betGame.selectedMarket.selectedOutCome
                                            .outcomeValue}
                                      </span>
                                    )}
                                </div>
                              </div>
                              <div className="text-muted">
                                {t(`${betGame.selectedMarket.marketName}`)}{" "}
                                {betGame.selectedMarket.selectedOutCome
                                  .outcomeValue !== 0
                                  ? betGame.selectedMarket.selectedOutCome
                                    .outcomeValue
                                  : ""}
                              </div>
                              {
                                betSlipDetails.betType === "SUPER_ODDS" && <div className="text-muted">
                                  {leagueDisplayName} {t("Season")} #{betSlipDetails.fkSeasonId},{" "}
                                  <span>
                                    {t("Week")} {betSlipDetails.fkWeekId}
                                  </span>
                                </div>
                              }
                              <div className="text-muted me-2">
                                {betSlipDetails.betType === "SUPER_ODDS" ? betGame.outcomeDescription : <span>{t(`${betGame.homeTeam}`)} {t("VS")} {t(`${betGame.awayTeam}`)}</span>}
                              </div>
                            </div>
                          </div>
                          <h3>
                            <StyledBetslipOdds className="badge text-secondary rounded-pill betslip-odds-text">
                              {betGame.selectedMarket.selectedOutCome.odds}
                            </StyledBetslipOdds>
                          </h3>
                        </li>
                      );
                    })}
                  </ul>
                )}
                {betSlipDetails?.betType === "SINGLE_BET" || betSlipDetails?.betType === "COMBO_BET" && (
                  <StyledBetslipBonus className="bg-info p-2 text-secondary text-center">
                    <Bonus />
                  </StyledBetslipBonus>
                )}
                {/* --- */}
                {/* <div className="p-2 pt-3 d-flex justify-content-start align-items-center bg-white text-dark">
                  <div className="me-2 text-muted">{sessionCurrencyCode ? sessionCurrencyCode : currencyCode}</div>
                  <StyledBetslipStakeBtn selected={parseFloat(stakeValue) === 50}
                    className={`btn btn-sm w-25 me-2 border border-1 stakeBtn ${parseFloat(stakeValue) === 50
                      ? "bg-secondary text-white"
                      : "bg-info border-info"
                      }`}
                    onClick={(e) => {
                      updateStakeValue(50);
                    }}
                  >
                    +50
                  </StyledBetslipStakeBtn>
                  <StyledBetslipStakeBtn selected={parseFloat(stakeValue) === 100}
                    className={`btn btn-sm w-25 me-2 border border-1 stakeBtn ${parseFloat(stakeValue) === 100
                      ? "bg-secondary text-white"
                      : "bg-info border-info"
                      }`}
                    onClick={(e) => {
                      updateStakeValue(100);
                    }}
                  >
                    +100
                  </StyledBetslipStakeBtn>
                  <StyledBetslipStakeBtn selected={parseFloat(stakeValue) === 250}
                    className={`btn btn-sm w-25 me-2 border border-1 stakeBtn ${parseFloat(stakeValue) === 250
                      ? "bg-secondary text-white"
                      : "bg-info border-info"
                      }`}
                    onClick={(e) => {
                      updateStakeValue(250);
                    }}
                  >
                    +250
                  </StyledBetslipStakeBtn>
                  <StyledBetslipStakeBtn selected={parseFloat(stakeValue) === 500}
                    className={`btn btn-sm w-25 me-2 border border-1 stakeBtn ${parseFloat(stakeValue) === 500
                      ? "bg-secondary text-white"
                      : "bg-info border-info"
                      }`}
                    onClick={(e) => {
                      updateStakeValue(500);
                    }}
                  >
                    +500
                  </StyledBetslipStakeBtn>
                  <input
                    className="bg-white text-end border border-info rounded fw-bold text-start betslip-input"
                    type={"text"}
                    onChange={(e) => {
                      selectedStake(e);
                    }}
                    value={stakeValue || ""}
                    placeholder={t("Stake")}
                    pattern="[0-9]"
                  />
                </div>  */}

                <div className="container py-4 bg-white">
                  <div
                    className="flex-grow-1 text-center p-2 my-2 px-4"
                    style={{
                      minWidth: '200px',
                      backgroundColor: '#e5e5e5',
                      borderRadius: '6px',
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"center"
                    }}
                  >
                    <div onClick={()=> updateStakeValue(-generalConfig.minStake)} style={{height:"25px", width:"25px", opacity: stakeValue <= generalConfig.minStake ? "0.4" : ""}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-6 h-6"
                        fill="black"
                      >
                        <path d="M12,23.6C5.6,23.6.4,18.4.4,12S5.6.4,12,.4s11.6,5.2,11.6,11.6-5.2,11.6-11.6,11.6ZM12,1.4C6.2,1.4,1.4,6.2,1.4,12s4.7,10.6,10.6,10.6,10.6-4.7,10.6-10.6S17.8,1.4,12,1.4ZM18.2,11.1H5.8v1.8h12.4v-1.8Z" />
                      </svg>
                    </div>
                    <div style={{flex:1}}>


                      <div style={{ color: '#000', fontSize: '12px' }}>
                        Enter stake Amount  <span className="fw-bold">{sessionCurrencyCode ? sessionCurrencyCode : currencyCode}</span>
                      </div>
                      <input
                        className="form-control-plaintext text-center"
                        type={"text"}
                        onChange={(e) => {
                          selectedStake(e);
                        }}
                        value={stakeValue || ""}
                        pattern="[0-9]"
                        style={{
                          color: '#000',
                          fontSize: '20px',
                          fontWeight: 'bold',
                        }}
                      />
                    </div>
                    <div onClick={()=> updateStakeValue(generalConfig.minStake)} style={{height:"25px", width:"25px", opacity: stakeValue >= generalConfig.maxStake ? "0.4" : ""}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-6 h-6"
                        fill="black"
                      >
                        <path d="M12,23.6C5.6,23.6.4,18.4.4,12S5.6.4,12,.4s11.6,5.2,11.6,11.6-5.2,11.6-11.6,11.6ZM12,1.4C6.2,1.4,1.4,6.2,1.4,12s4.7,10.6,10.6,10.6,10.6-4.7,10.6-10.6S17.8,1.4,12,1.4ZM18.2,11.1H5.8v1.8h12.4v-1.8ZM12.9,18.2V5.8h-1.8v12.4h1.8Z" />
                      </svg>
                    </div>
                  </div>
                  <div className="row g-2">
                    {[50, 100, 250, 500].map((value) => (
                      <div key={value} className="col-6 col-md-3">
                        <StyledBetslipStakeBtn
                          onClick={() => updateStakeValue(value)}
                          className="btn w-100 fw-bold bg-info border-info"
                          style={{
                            backgroundColor: '#e5e5e5',
                            color: '#f27c1e',
                            fontSize: '14px',
                            padding: '6px',
                          }}
                        >
                          +{value}
                        </StyledBetslipStakeBtn>
                      </div>
                    ))}
                  </div>
                </div>

                {/*  */}

                <div className="p-2 d-flex justify-content-between align-items-center bg-white text-dark">
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>{t("Total Odds")}</h6>
                      <h6>{calculatedBetSlip.totalOdds || 0}</h6>
                    </div>
                    {showBonus && (
                      <React.Fragment>
                        {
                          calculatedBetSlip.stakeTaxAmount > 0 &&
                          <div className="d-flex justify-content-between align-items-center">
                            <h6>
                              {t("Excise Tax")}
                              {/* ({calculatedBetSlip.stakeTaxPercentage || 0}%) */}
                            </h6>
                            <h6>
                              {sessionCurrencyCode ? sessionCurrencyCode : currencyCode}{" "}
                              {calculatedBetSlip.stakeTaxAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                            </h6>
                          </div>
                        }
                        {
                          calculatedBetSlip.winningsTaxAmount > 0 &&
                          <div className="d-flex justify-content-between align-items-center">
                            <h6>
                              {t("Withholding Tax")}
                              {/* ({calculatedBetSlip.winningsTaxPercentage || 0}%) */}
                            </h6>
                            <h6>
                              {sessionCurrencyCode ? sessionCurrencyCode : currencyCode}{" "}
                              {calculatedBetSlip.winningsTaxAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                            </h6>
                          </div>
                        }
                      </React.Fragment>
                    )}
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>{t("Bonus")} ({calculatedBetSlip.bonusPercentage || 0}%)</h6>
                      <h6>
                        {sessionCurrencyCode ? sessionCurrencyCode : currencyCode} {calculatedBetSlip.bonusAmount && calculatedBetSlip.bonusAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>{t("Total Returns")}</h6>
                      <h6>
                        {sessionCurrencyCode ? sessionCurrencyCode : currencyCode}{" "}
                        {calculatedBetSlip.finalReturnAmount && calculatedBetSlip.finalReturnAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) || 0}
                      </h6>
                    </div>
                  </div>
                  <div className="mx-2 mb-2 pointer-hand" onClick={collapseIcon}>
                    <span className={calculatedBetSlip.stakeTaxAmount > 0 || calculatedBetSlip.winningsTaxAmount > 0 ? 'd-block' : 'd-none'}>
                      {showBonus ? <BsChevronUp /> : <BsChevronDown />}
                    </span>
                  </div>
                </div>
                <div
                  className="text-center text-secondary fw-bold bg-white"
                  style={{ minHeight: "20px" }}
                >
                  {!userSession.token || userSession.token == "undefined" ? (
                    <div>Please login to place bet</div>
                  ) : (
                    <>
                      <div>{stakeMinMaxErr}</div>
                      <div>
                        {calculationSpinner && (
                          <StyledLoader className="spinner-border spinner-border-sm me-2"></StyledLoader>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="p-2 bg-white text-dark">
                  {spinner ? (
                    <StyledPlaceBtn
                      disabled={true}
                      className="btn btn-secondary w-100 text-white p-2 fs-5 fw-bold"
                      type="button"
                    >
                      <span className="spinner-border spinner-border-sm me-2"></span>
                    </StyledPlaceBtn>
                  ) : (!userSession.token ||
                    userSession.token == "undefined") &&
                    queryUrlData?.referralLogin &&
                    queryUrlData?.referralRegister &&
                    queryUrlData?.referralRegister !== "undefined" &&
                    queryUrlData?.referralLogin !== "undefined" ? (
                    <div className="betslip_login">
                      <StyledPlaceBtn
                        className="btn btn-secondary w-100 text-white p-2 fs-5 fw-bold"
                        onClick={() => handleClick(queryUrlData?.referralLogin)}
                      >
                        <span>{t("Login")}</span>
                      </StyledPlaceBtn>
                      <StyledPlaceBtn
                        className="btn btn-secondary w-100 text-white p-2 fs-5 fw-bold"
                        onClick={() =>
                          handleClick(queryUrlData?.referralRegister)
                        }
                      >
                        <span>{t("Register")}</span>
                      </StyledPlaceBtn>
                    </div>
                  ) : (
                    <StyledPlaceBtn
                      disabled={
                        !userSession.token || userSession.token == "undefined"
                          ? true
                          : btnDisabled
                      }
                      className="btn btn-secondary w-100 text-white p-2 fs-5 fw-bold"
                      onClick={placeBet}
                    >
                      <span>{t("Place Bet")}</span>
                    </StyledPlaceBtn>
                  )}
                </div>
              </div>
            </div>
          </div>
        </StyledBetslipModal>
      </div>
    </React.Fragment>
  );
};
